import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Gallery.css";
import useGallery from "../../../../hooks/useGallery";
import { url } from "../../../../App";

const Gallery = () => {

  const { galleryItems } = useGallery();

  return (
    <div className="gallery-content">
      <Row xs={1} md={3} className="gx-0">
        {
          galleryItems?.map((item, index) => (
            <Col key={index} className="p-0 gallery">
              <img data-aos="zoom-in"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000" className="w-100 h-100" src={`${url}${item?.image}`} alt="gallery-item" />
            </Col>
          ))
        }
      </Row>
    </div>
  );
};

export default Gallery;
